import { axios } from '@Root/API'

export const edit = ({ id, text }) => {
  return axios.put(`application-questions/${id}`, { text })
}
